function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "\n    #eFSKlAu9Y0e3 {\n      animation-name: eFSKlAu9Y0e3_s_do, eFSKlAu9Y0e3_s_da;\n      animation-duration: 2500ms;\n      animation-fill-mode: forwards;\n      animation-timing-function: linear;\n      animation-direction: normal;\n      animation-iteration-count: infinite;\n    }\n\n    @keyframes eFSKlAu9Y0e3_s_do { \n      0% {stroke-dashoffset: 200} \n      40% {stroke-dashoffset: 0} \n      100% {stroke-dashoffset: -200}\n    }\n\n    @keyframes eFSKlAu9Y0e3_s_da { \n      0% {stroke-dasharray: 200}\n      40% {stroke-dasharray: 200}\n      100% {stroke-dasharray: 400, 300}\n    }\n\n    #eFSKlAu9Y0e4 {\n      animation: eFSKlAu9Y0e4_s_do 2500ms linear infinite normal forwards\n    }\n\n    @keyframes eFSKlAu9Y0e4_s_do { \n      0% {stroke-dashoffset: 200} \n      40% {stroke-dashoffset: 0} \n      60% {stroke-dashoffset: 0} \n      100% {stroke-dashoffset: -200}\n    }\n  ");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  id: "eFSKlAu9Y0e3",
  r: 31,
  transform: "translate(35 35)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#0070F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeDashoffset: 200,
  strokeDasharray: 200
}));

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  id: "eFSKlAu9Y0e4",
  points: "53.228415,19.062295 32.572623,39.638524 11.91694,19.062295 11.967642,30.707219 32.572623,51.232787 53.206086,30.397125",
  transform: "matrix(0 1-1 0 67.720222 2.574864)",
  fill: "#0070F5",
  fillOpacity: 0,
  fillRule: "evenodd",
  stroke: "#0070F5",
  strokeLinecap: "round",
  strokeDashoffset: 200,
  strokeDasharray: "200,300"
});

function SvgKrowLogoLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eFSKlAu9Y0e1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 70 70",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrowLogoLoading);
export default __webpack_public_path__ + "static/media/krow-logo-loading.fb07df33.svg";
export { ForwardRef as ReactComponent };